@if (lineItems.length) {
  @if (pinned() === 'left') {
    @for (item of lineItems; track item) {
      <div
        class="cell pinned-left flex h-[40px] truncate bg-aux-gray-light px-[10px] leading-[40px]"
      >
        <div
          #text
          class="truncate"
          [ngClass]="{
            'w-1/2': item.isPivotedOn2Attr,
            'pr-[5px]': item.isPivotedOn2Attr,
          }"
          [auxTooltip]="text.offsetWidth < text.scrollWidth ? item.attr1_value : ''"
        >
          {{ item.attr1_value }}
        </div>

        @if (item.isPivotedOn2Attr) {
          <div
            #text
            class="w-1/2 truncate pl-[5px]"
            [auxTooltip]="text.offsetWidth < text.scrollWidth ? item.attr2_value : ''"
          >
            {{ item.attr2_value }}
          </div>
        }
      </div>
    }
  } @else if (pinned() === 'right') {
    @for (item of lineItems; track item) {
      <div
        class="cell pinned-right h-[40px] truncate bg-aux-gray-light px-[10px] text-right leading-[40px]"
      ></div>
    }
  } @else {
    @for (item of lineItems; track item) {
      <div class="cell flex h-[40px] leading-[40px]">
        <div class="w-[150px] truncate bg-aux-gray-light px-[10px] text-right">
          <a
            class="aux-link cursor-pointer"
            [ngClass]="{
              'no-underline': !item.amount,
            }"
            (click)="redirectToIntegrationPage()"
          >
            {{
              utils.currencyFormatter(
                item.amount,
                {},
                params.data.expense_amounts.invoice_total.currency ||
                  params.data.organization.currency
              )
            }}
          </a>
        </div>
        <div class="flex-1 bg-aux-gray-light px-[10px]"></div>
      </div>
    }
  }
}
